import React from "react";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import styles from "./AssistantNewForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SaveIcon from "../../assets/icons/SaveIcon";
import {
  setActiveAssistant,
  setNewAssistant,
  setUpdateAssistant,
} from "../../store/slices/assistantSlice";
import {
  getAssistantList,
  getInstructionsList,
  postNewAssistant,
  putAssistant,
  postAddAssistantFiles,
} from "../../utils/api/actions/assistant";
import createDataAssistant from "../../utils/methods/createDataAssistant";
import { AssistantFormModule } from "./modules/AssistantFormModule/AssistantFormModule";
import { MainTabsModule } from "./modules/MainTabsModule/MainTabsModule";
import { validateFields } from "../../utils/methods/validationField";

export const AssistantNewForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const isFromTestScreen = location.state?.fromTestScreen === true;

  const errorFields = (message) =>
    toast.error(message, {
      toastId: `${message}-customId`,
    });

  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  const assistants = useSelector((state) => state.assistant.dataAssistants);
  const newAssistant = useSelector((state) => state.assistant.newAssistant);
  const { activeAssistant, updateAssistant } = useSelector(
    (state) => state.assistant
  );

  const instructions = useSelector(
    (state) => state?.instructions?.instructions
  );
  const id =
    useSelector((state) => state.user?.data?.id) ||
    localStorage.getItem("@storage_User_Id");

  React.useEffect(() => {
    dispatch(getAssistantList(id));
  }, [dispatch, id]);

  React.useEffect(() => {
    if (instructions) return;
    dispatch(getInstructionsList());
  }, [dispatch, instructions]);

  const handlerSendAssistantData = async () => {
    if (newAssistant && !updateAssistant) {
      if (isEmptyObject(newAssistant)) {
        if (validateFields(newAssistant, errorFields)) {
          dispatch(
            postNewAssistant(createDataAssistant(newAssistant), navigate)
          );
        }
      }
    } else {
      if (isEmptyObject(updateAssistant)) {
        if (validateFields(updateAssistant, errorFields)) {
          const updatedAssistant = await dispatch(
            putAssistant(updateAssistant)
          );

          if (updatedAssistant && updateAssistant.files?.length > 0) {
            const formData = new FormData();
            formData.append("userId", id);
            formData.append("assistantId", updatedAssistant.id);

            const newFiles = updateAssistant.files.filter((file) => !file.id);
            if (newFiles.length > 0) {
              newFiles.forEach((file) => {
                formData.append("files", file);
              });

              await dispatch(postAddAssistantFiles(formData, () => {}));
            }
          }

          await dispatch(setUpdateAssistant(null));
          navigate("/assistants");
        }
      } else {
        console.log("error");
      }
    }
  };

  const handleCancel = () => {
    if (isFromTestScreen) {
      navigate(`/assistants/${activeAssistant.id}/test`);
    } else {
      navigate("/assistants");
      localStorage.setItem("activeAssistant", JSON.stringify(assistants[0]));
      dispatch(setActiveAssistant(assistants[0]));
    }
    dispatch(setUpdateAssistant(null));
    dispatch(setNewAssistant(null));
  };

  const actionsButton = [
    {
      title: "Сохранить",
      icon: <SaveIcon />,
      className: styles.addButton,
      titleClassName: styles.titleAddButton,
      onClick: handlerSendAssistantData,
    },
    {
      title: "Отмена",
      className: styles.cancelButton,
      titleClassName: styles.titleCancelButton,
      onClick: handleCancel,
    },
  ];

  return (
    <div className={styles.container}>
      <ScreenHeader title={"Ассистенты"} actions={actionsButton} />
      <p className={styles.assistantName}>
        {updateAssistant
          ? updateAssistant.name
          : newAssistant
          ? newAssistant.name
          : "Имя ассистента"}
      </p>
      <div className={styles.card}>
        <AssistantFormModule newAssistant={newAssistant} />
        <MainTabsModule newAssistant={newAssistant} />
      </div>
    </div>
  );
};
